import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import '../../versions/style/tablestyle.css';
import '../../versions/tabs/Table.css';

// project imports
import { Card } from '@mui/material';
// import MainCard from 'ui-component/cards/MainCard';
import ClientCustomChange from './client-custom-change-tab/ClientCustomChange';
import AnualSupportCost from './annual-support-tab/AnualSupportCost';
import ProgramConfiguration from './program-configuration/ProgramConfiguration';
import Teamandcost from './team-and-cost-tab/Teamandcost';
import AssumptionQuestion from './assumption-and-question-tab/AssumptionQuestion';
import { useSearchParams } from 'react-router-dom';
import useUnsaveChanges from 'views/versions/tabs/team-and-cost-tab/custom-hook/useUnsaveChanges';
import { confirmChangeTab } from 'views/versions/tabs/Constfunctions';

const NewVersion = ({ view }) => {
  const [tab, setTab] = React.useState('Package-Selection');

  //  Custom hook for unsave alert.
  const [isChangedPrompt, setDirty, setNotDirty] = useUnsaveChanges();

  const handleChange = (event, newValue) => {
    const leaveTab = confirmChangeTab(isChangedPrompt, setNotDirty);
    if (leaveTab !== null) {
      setTab(newValue);
    }
  };

  // getting value of parameter in url

  const [searchParams] = useSearchParams();
  const ClientId = parseInt(searchParams.get('ClientId'));
  const ProjectId = parseInt(searchParams.get('ProjectId'));
  const EstimationId = parseInt(searchParams.get('EstimationId'));
  const Version = parseInt(searchParams.get('Version'));

  return (
    <Card>
      <Box sx={{ width: '100%', padding: '20px' }}>
        <TabContext value={tab}>
          <Tabs
            value={tab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
          >
            <Tab value="Package-Selection" label="Package Selection" />
            <Tab value="Client-Custom-Change" label="Client Custom Change" />
            <Tab value="Team-&-Cost" label="Team & Cost" />

            <Tab value="Annual-Support-Cost" label="Annual Support Cost" />
            <Tab value="Assumptions-&-Questions" label="Assumptions & Questions"></Tab>
          </Tabs>

          <TabPanel value="Package-Selection">
            <ProgramConfiguration
              view={view}
              setTab={setTab}
              ClientId={ClientId}
              ProjectId={ProjectId}
              EstimationId={EstimationId}
              Version={Version}
            />
          </TabPanel>
          <TabPanel value="Client-Custom-Change" style={{ height: '450' }}>
            <ClientCustomChange
              view={view}
              setTab={setTab}
              ClientId={ClientId}
              ProjectId={ProjectId}
              EstimationId={EstimationId}
              Version={Version}
            />
          </TabPanel>
          <TabPanel value="Team-&-Cost">
            <Teamandcost
              view={view}
              setTab={setTab}
              ClientId={ClientId}
              ProjectId={ProjectId}
              EstimationId={EstimationId}
              Version={Version}
              isChangedPrompt={isChangedPrompt}
              setDirty={setDirty}
              setNotDirty={setNotDirty}
            />
          </TabPanel>

          <TabPanel value="Annual-Support-Cost">
            <AnualSupportCost
              view={view}
              setTab={setTab}
              ClientId={ClientId}
              ProjectId={ProjectId}
              EstimationId={EstimationId}
              Version={Version}
              isChangedPrompt={isChangedPrompt}
              setDirty={setDirty}
              setNotDirty={setNotDirty}
            />
          </TabPanel>

          <TabPanel value="Assumptions-&-Questions">
            <AssumptionQuestion
              view={view}
              setTab={setTab}
              ClientId={ClientId}
              ProjectId={ProjectId}
              EstimationId={EstimationId}
              Version={Version}
              isChangedPrompt={isChangedPrompt}
              setDirty={setDirty}
              setNotDirty={setNotDirty}
            />
          </TabPanel>
        </TabContext>
      </Box>
    </Card>
  );
};

export default NewVersion;
